<template>
  <div>
    <a-spin type="loading" :spin="loading" tip="加载中"></a-spin>
  </div>
</template>

<script>
import services from "../../assets/js/services";

export default {
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      loading: true
    }
  },
  async mounted () {
    let code = this.$route.query.code
    let result = await services.getAppsLoginInfo({ label: "shijian", school_code: this.school_code })
    if (!result.data.is_open_app) this.$router.push(`/${this.school_code}/noauth`)
    this.$router.push(`/${this.school_code}/student?code=${code}`)
  }
}
</script>

<style lang="less">
.ant-spin .ant-spin-dot {
    color: #c0403a;
    .ant-spin-dot-item {
        background-color: #c0403a;
    }
}
</style>